import SvgIcon, { SvgIconOwnProps } from '@mui/material/SvgIcon';

export default function ImageIcon(props: SvgIconOwnProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="currentColor">
        <path d="M14.368 1.14877C14.6442 1.14877 14.868 1.37263 14.868 1.64877V14.3593C14.868 14.6354 14.6442 14.8593 14.368 14.8593H1.66271C1.38657 14.8593 1.16271 14.6354 1.16271 14.3593V1.64877C1.16271 1.37263 1.38657 1.14877 1.66271 1.14877H14.368ZM14.2222 0H1.77778C0.8 0 0 0.8 0 1.77778V14.2222C0 15.2 0.8 16 1.77778 16H14.2222C15.2 16 16 15.2 16 14.2222V1.77778C16 0.8 15.2 0 14.2222 0ZM10.2957 8.39955C10.0976 8.13576 9.70286 8.13274 9.50074 8.39346L7.61828 10.8218C7.42203 11.075 7.04169 11.0809 6.83766 10.834L5.73072 9.49428C5.52686 9.24755 5.14689 9.25322 4.95048 9.50593L3.29374 11.6376C3.03846 11.9661 3.27253 12.4444 3.68852 12.4444H12.3326C12.7447 12.4444 12.9799 11.9738 12.7324 11.6442L10.2957 8.39955Z" />
        <path d="M12 5C12 5.55228 11.5523 6 11 6C10.4477 6 10 5.55228 10 5C10 4.44772 10.4477 4 11 4C11.5523 4 12 4.44772 12 5Z" />
      </svg>
    </SvgIcon>
  );
}
